import { render } from "./BillingInvoiceModal.vue?vue&type=template&id=b1aa551a&scoped=true"
import script from "./BillingInvoiceModal.vue?vue&type=script&lang=js"
export * from "./BillingInvoiceModal.vue?vue&type=script&lang=js"

import "./BillingInvoiceModal.vue?vue&type=style&index=0&id=b1aa551a&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1aa551a"]])

export default __exports__